import {
  LOAD_OPEN_INCIDENT,
  LOAD_OPEN_INCIDENT_SUCCESS,
  LOAD_OPEN_INCIDENT_FAILED,
  LOAD_CLOSE_INCIDENT,
  LOAD_CLOSE_INCIDENT_SUCCESS,
  LOAD_CLOSE_INCIDENT_FAILED,
  SORT_INCIDENTS,
  SELECT_INCIDENT_SEARCH,
  SELECT_INCIDENT_PRIORITY_FILTER,
  SELECT_INCIDENT_STATUS_FILTER,
  CLEAR_INCIDENT_STATUS_FILTER,
  ADD_RESOLUTION_PROPOSAL_ACTION,
  ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS,
  ADD_RESOLUTION_PROPOSAL_ACTION_FAILED,
  ADD_COMMENT,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILED
} from "./incidentActionTypes";

export function loadOpenIncident() {
  return { type: LOAD_OPEN_INCIDENT };
}

export function loadOpenIncidentSuccess(logIncident) {
  return { type: LOAD_OPEN_INCIDENT_SUCCESS, logIncident };
}

export function loadOpenIncidentFailed(message) {
  return { type: LOAD_OPEN_INCIDENT_FAILED, message };
}

export function loadCloseIncident() {
  return { type: LOAD_CLOSE_INCIDENT };
}

export function loadCloseIncidentSuccess(logIncident) {
  return { type: LOAD_CLOSE_INCIDENT_SUCCESS, logIncident };
}

export function loadCloseIncidentFailed(message) {
  return { type: LOAD_CLOSE_INCIDENT_FAILED, message };
}

export function sortIncident(sort) {
  return { type: SORT_INCIDENTS, sort };
}

export function filterIncidentSearch(value) {
  return { type: SELECT_INCIDENT_SEARCH, value };
}

export function filterIncidentPriority(value) {
  return { type: SELECT_INCIDENT_PRIORITY_FILTER, value };
}

export function filterIncidentStatus(value) {
  return { type: SELECT_INCIDENT_STATUS_FILTER, value };
}

export function clearIncidentStatus() {
  return { type: CLEAR_INCIDENT_STATUS_FILTER };
}

export function addResolutionProposalActionSuccess(payload) {
  return { type: ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS, payload };
}

export function addResolutionProposalActionFailed(message) {
  return { type: ADD_RESOLUTION_PROPOSAL_ACTION_FAILED, message };
}

export function addResolutionProposalAction(incidentIdInput, commentIdInput, actionType, commentTypeInput) {
  return {
    type: ADD_RESOLUTION_PROPOSAL_ACTION, payload: { incidentId: incidentIdInput, commentId: commentIdInput, action: actionType, commentType: commentTypeInput }
  };
}
export function updateCommentType(incidentIdInput, commentIdInput, actionType, commentTypeInput) {
  return {
    type: ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS, payload: { incidentId: incidentIdInput, commentId: commentIdInput, action: actionType, commentType: commentTypeInput }
  };
}

export function addComment(incidentId, comment, commentType) {
  return { type: ADD_COMMENT, payload: { incidentId: incidentId, comment: comment, commentType: commentType } };
}
export function addCommentSuccess(payload) {
  return { type: ADD_COMMENT_SUCCESS, payload };
}
export function addCommentFailed(message) {
  return { type: ADD_COMMENT_FAILED, message };
}



// WEBPACK FOOTER //
// ./src/incidents/incidentActions.js